import { Adapter as r } from "../../adapter.js";
import { SpecialHoursPerServiceSlotModel as o } from "./specialHoursPerServiceSlot.model.js";
class l extends r {
  adapt(e) {
    return new o({
      fullDay: e.full_day,
      endTime: e.end_time,
      startTime: e.start_time,
      weekDays: e.week_days,
      closed: e.closed,
      services: e.services ?? [],
      timezone: e.timezone
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  l as SpecialHoursPerServiceSlotAdapter
};
//# sourceMappingURL=specialHoursPerServiceSlot.adapter.js.map
